import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Tabs from '@bibliocommons/base-tabs';
import { QuotationsContainer } from '../Quotations';
import { SummariesContainer } from '../Summaries';
import { VideosContainer } from '../Videos';
import { AgeSuitabilityContainer } from '../AgeSuitability';
import { ContentNoticesContainer } from '../ContentNotices';

const UGC_TABS = {
  QUOTATIONS: 'quotations',
  SUMMARIES: 'summaries',
  VIDEOS: 'videos',
  SUITABILITY: 'suitability'
};

export class UGCTabs extends React.PureComponent {
  state = { selectedTab: UGC_TABS.QUOTATIONS };

  handleSelect = selectedTab => {
    this.setState({ selectedTab });
  };

  constructLabel(name) {
    const { summary } = this.props;
    const contentAdvisoriesCount = summary.getIn(['contentAdvisories', 'total'], 0);
    const ageSuitabilitiesCount = summary.getIn(['ageSuitabilities', 'average'], 0);

    let label = this.props.intl.formatMessage({ id: name });
    let count = summary.getIn([name, 'total']);
    if (name === UGC_TABS.SUITABILITY) {
      if (contentAdvisoriesCount) {
        count = contentAdvisoriesCount;
      }
      if (ageSuitabilitiesCount) {
        count = ageSuitabilitiesCount;
      }
      if (count) {
        label += ageSuitabilitiesCount ? ` (${count}+)` : ` (${count})`;
      }
    } else if (count) {
      label += ` (${count})`;
    }

    return label;
  }

  constructOptions() {
    const tabNames = [UGC_TABS.QUOTATIONS, UGC_TABS.SUMMARIES, UGC_TABS.VIDEOS, UGC_TABS.SUITABILITY];

    return tabNames.map(name => {
      return {
        label: this.constructLabel(name),
        selected: this.state.selectedTab === name,
        value: name
      };
    });
  }

  renderContent = () => {
    switch (this.state.selectedTab) {
      case UGC_TABS.QUOTATIONS: {
        return <QuotationsContainer />;
      }
      case UGC_TABS.SUMMARIES: {
        return <SummariesContainer />;
      }
      case UGC_TABS.VIDEOS: {
        return <VideosContainer />;
      }
      case UGC_TABS.SUITABILITY: {
        return (
          <>
            <AgeSuitabilityContainer />
            <ContentNoticesContainer />
          </>
        );
      }
      default:
        return null;
    }
  };

  render() {
    return (
      <div className="cp-ugc-tabs">
        <FormattedMessage tagName="h3" id="community_contributions" />
        <Tabs options={this.constructOptions()} renderContent={this.renderContent} handleSelect={this.handleSelect} />
      </div>
    );
  }
}

UGCTabs.propTypes = {
  summary: ImmutablePropTypes.map
};

export default injectIntl(UGCTabs);
